export default function ESFJ(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “سفیر”</h1>{" "}
          <blockquote>
            <p>
              یکدیگر را تشویق کنید، بالا ببرید و تقویت کنید. چرا که وقتی یک نفر
              انرژی مثبت را دریافت کند همه ما آن را احساس می&zwnj;کنیم.
            </p>{" "}
            <footer>Deborah Day</footer>
          </blockquote>{" "}
          <p>
            باید گفت افراد دارای شخصیت مشاور پرطرفدار هستند - البته به این دلیل
            که کلمه بهتری نداریم - که از این بابت هم منطقی است که این گونه
            شخصیتی بسیار رایج است و تا دوازده درصد جمعیت را تشکیل می&zwnj;دهد.
            مشاوران در دبیرستان، سردسته تشویق&zwnj;کنندگان است که فضا را ایجاد
            می&zwnj;کنند خود را در معرض توجه قرار می&zwnj;دهند و تیم&zwnj;های
            خود را به سمت پیروزی و شهرت هدایت می&zwnj;کنند. مشاوران در ادامه
            زندگی خود همچنان از حمایت دوستان و عزیزانشان بهره می&zwnj;گیرند و به
            سازماندهی گردهمایی&zwnj;های اجتماعی می&zwnj;پردازند و هر کاری که
            بتوانند می&zwnj;کنند تا مطمئن شوند که همه راضی باشند.
          </p>{" "}
          <blockquote className="no-footer">
            <p>
              شخصیت مشاور در قلب خود موجودی اجتماعی است و خواستار به&zwnj;روز
              ماندن و انجام کارهایی است که دوستانش انجام می&zwnj;دهند.
            </p>
          </blockquote>{" "}
          <p>
            احتمالاً بحث در مورد نظریه&zwnj;های علمی یا سیاست بین&zwnj;المللی
            برای مدت زمان طولانی علاقه مشاوران را برنمی&zwnj;انگیزد. مشاوران
            بیشتر به کارهای محسوس و عملی از جمله بهبود موقعیت اجتماعی خود و در
            نظر گرفتن افراد دیگر علاقه&zwnj;مند هستند. پیگیری آنچه که در
            اطرافشان اتفاق می&zwnj;افتد مهمترین روش گذران وقت برای
            شخصیت&zwnj;های مشاور است، اما در عین حال از قدرت خود نیز
            به&zwnj;خوبی استفاده می&zwnj;کنند.
          </p>{" "}
          <h2>احترام گذاشتن به خرد رهبری</h2>{" "}
          <p>
            مشاوران افراد نوع&zwnj;دوستی هستند و مسئولیت خود را برای کمک کردن و
            انجام کار درست جدی می&zwnj;گیرند. با این حال مشاوران، بر خلاف
            گونه&zwnj;های شخصیتی آرمان&zwnj;گراتر قطب&zwnj;نمای اخلاقی خود را بر
            مبنای سنن و قوانین حاکم تنظیم می&zwnj;کنند و به حفظ اقتدار و قوانین
            می&zwnj;پردازند تا اینکه بخواهند اخلاق خود را از فلسفه یا عرفان
            استخراج نمایند. با این همه، مهم است مشاوران به یاد داشته باشند که
            افراد دارای پیشینه&zwnj;ها و دیدگاه&zwnj;های مختلفی هستند و آنچه که
            ممکن است درست به نظر برسد همواره حقیقتی مطلق نیست.
          </p>{" "}
          <p>
            افراد دارای گونه شخصیتی مشاور عاشق این هستند که در خدمت باشند، از هر
            نقشی که به آنها اجازه بدهد به شیوه&zwnj;ای معنادار مشارکت کنند لذت
            می&zwnj;برند، تا زمانی که بدانند قدرشان دانسته می&zwnj;شود. این
            مسئله به ویژه در خانه آشکار است چرا که مشاوران همسران و والدینی
            وفادار و متعهد هستند. شخصیت مشاور به سلسله مراتب احترام
            می&zwnj;گذارد و حداکثر تلاش خود را می&zwnj;کند تا در نزد مقامات چه
            در خانه و چه در محل کار جایگاهی پیدا کند تا بتواند کاری کند که امور
            برای همه روشن، پایدار و سازمان&zwnj;یافته باشد.
          </p>{" "}
          <h2>ارتباطات هماهنگ</h2>{" "}
          <p>
            مشاوران حمایتگر و اهل بیرون رفتن هستند و همیشه می&zwnj;توانید آنها
            را در مهمانی&zwnj;ها پیدا کنید - یعنی همان&zwnj;هایی که برای گفتگو و
            خندیدن با همه وقت پیدا می&zwnj;کنند! اما تعهد آنها فراتر از این سر
            زدن به همه است چرا که ناچار هستند چنین کاری انجام دهند. افراد دارای
            شخصیت مشاور واقعاً از شنیدن مسائل مربوط به روابط و فعالیت&zwnj;های
            دوستان خود، به خاطر آوردن جزئیات کوچک و آماده صحبت بودن توأم با گرمی
            و حساسیت در مورد مسائل لذت می&zwnj;برند. اگر اوضاع خوب نبوده، یا در
            اتاق تنشی وجود داشته باشد، مشاوران تلاش می&zwnj;کنند به موضوع
            بپردازند و هماهنگی و پایداری را به گروه برگردانند.
          </p>{" "}
          <p>
            مشاوران با داشتن شخصیتی کاملاً گریزان از جدال، مقدار زیادی از انرژی
            خود را صرف ایجاد نظم اجتماعی می&zwnj;کنند و برنامه&zwnj;ها و
            رویدادهای سازمان&zwnj;دهی شده را به فعالیت&zwnj;های نامشخص و بداهه
            ترجیح می&zwnj;دهند. افراد این گونه شخصیت تلاش زیادی را صرف
            فعالیت&zwnj;هایی می&zwnj;کنند که ترتیب داده&zwnj;اند و اگر
            ایده&zwnj;هایشان رد شود یا افراد به آنها علاقه&zwnj;ای نداشته باشند
            احساساتشان جریحه&zwnj;دار خواهد شد. مجدداً یادآور می&zwnj;شود که مهم
            است مشاوران به یاد داشته باشند که افراد دارای پیشینه&zwnj;های مختلفی
            هستند و بی&zwnj;علاقگی به معنای اظهار نظر در مورد آنها یا
            فعالیت&zwnj;هایی که تدارک دیده&zwnj;اند نیست - بلکه صرفاً به این
            دلیل است که علاقه&zwnj;ای به آن ندارند.
          </p>{" "}
          <p>
            بزرگترین چالش مشاوران کنار آمدن با حساسیتشان است - سایر افراد مخالف
            هستند و انتقاد می&zwnj;کنند، درست است که چنین مسئله&zwnj;ای دردناک
            است اما بخشی از واقعیت زندگی است. بهترین کاری که فردی با گونه شخصیتی
            مشاور می&zwnj;تواند انجام بدهد این است که کاری را انجام دهد که به
            بهترین نحو قادر به انجام آن است: ایفای نقش الگو، مراقبت از آنچه که
            قدرت مراقبت از آن را دارد، و لذت بردن از اینکه خیلی از افراد قدردان
            زحمات وی هستند.
          </p>
        </article>
      </div>
    </div>
  );
}
